export enum eToKhaiStatus {
  TAO_MOI = 1,
  CHO_CQT = 2,
  CQT_TU_CHOI = 3,
  CQT_DONG_Y = 4,
  CQT_TIEP_NHAN = 5,
  DA_GUI_CQT = 6,
  LOI_THONG_DIEP = 7,
}
